module.exports = __webpack_public_path__ + "static/media/empleada1.89157910.jpg";